import { render, staticRenderFns } from "./SubcontractGoodReceiptSuggestionDetailScan.vue?vue&type=template&id=5a567c40&scoped=true&"
import script from "./SubcontractGoodReceiptSuggestionDetailScan.vue?vue&type=script&lang=js&"
export * from "./SubcontractGoodReceiptSuggestionDetailScan.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractGoodReceiptSuggestionDetailScan.vue?vue&type=style&index=0&id=5a567c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a567c40",
  null
  
)

export default component.exports